import { nanoid } from "nanoid";

import Translate from "utils/translate";

const { t } = new Translate("notifications");

export const NOTIFICATION_ADD = "NOTIFICATION_ADD";
export const NOTIFICATION_REMOVE = "NOTIFICATION_REMOVE";

export const removeNotification = (notificationID) => (dispatch) =>
  dispatch({
    type: NOTIFICATION_REMOVE,
    meta: { notificationID },
  });

export const removeNotificationDelayed =
  (notificationID, dismissAfter = 5) =>
  (dispatch) => {
    setTimeout(() => dispatch(removeNotification(notificationID)), dismissAfter * 1000);
  };

export const show = (title, message, type) => (dispatch) =>
  dispatch({
    type: NOTIFICATION_ADD,
    payload: {
      notification: {
        id: nanoid(),
        title,
        message,
        type,
      },
    },
  });

export const showError = (title = t("defaultErrorTitle"), message) => show(title, message, "error");

export const showWarning = (title, message = "") => show(title, message, "warning");

export const showInfo = (title, message = "") => show(title, message, "info");

export const showSuccess = (title, message = "") => show(title, message, "success");
